import { createSlice } from '@reduxjs/toolkit';
import MainService from '../services/MainService';
import errorHandle from './errorHandle';

export const mainSlice = createSlice({
  name: 'main',
  initialState: {
    candidateTags: [],
    members: [],
    couponList: [],
    gameList: [],
    botList: [],
    isLoading: false,
  },
  reducers: {
    setCouponList: (state, action) => ({
      ...state,
      couponList: action.payload,
    }),
    setGameList: (state, action) => ({
      ...state,
      gameList: action.payload,
    }),
    setIsLoading: (state, action) => ({
      ...state,
      isLoading: action.payload,
    }),
    setState: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const { setCouponList, setGameList, setIsLoading, setState } =
  mainSlice.actions;

export const findTag =
  (tagName, orgId, customerId, options) => async dispatch => {
    try {
      dispatch(setIsLoading(true));

      const result = await MainService.findTagV3(
        tagName,
        orgId,
        customerId,
        options,
        ['name'],
      );
      const tags = result.data.map(tag => ({
        id: tag._id,
        name: tag._id,
      }));
      dispatch(setState({ candidateTags: tags }));
      dispatch(setIsLoading(false));
    } catch (error) {
      dispatch(errorHandle(error));
    }
  };

export const getOrganizationMembers = options => async (dispatch, getState) => {
  try {
    const { organization } = getState();

    const result = await MainService.getOrganizationMembers({
      org: organization,
      ...options,
    });

    dispatch(setState({ members: result }));
  } catch (error) {
    dispatch(errorHandle(error));
  }
};

export const getCouponList = orgId => async dispatch => {
  try {
    dispatch(setCouponList([]));

    const result = await MainService.getCouponList(orgId);

    dispatch(setCouponList(result));
  } catch (error) {
    dispatch(setCouponList([]));
    dispatch(errorHandle(error));
  }
};

export const getGameList = orgId => async dispatch => {
  try {
    dispatch(setGameList([]));
    const result = await MainService.getGameList(orgId);

    dispatch(setGameList(result));
  } catch (error) {
    dispatch(setGameList([]));
    dispatch(errorHandle(error));
  }
};

export const getService = (orgId, provider) => async dispatch => {
  try {
    const result = await MainService.getService(orgId, provider);

    dispatch(setState({ [provider]: result }));
  } catch (error) {
    dispatch(errorHandle(error));
  }
};

export const getTriggerBot = orgId => async dispatch => {
  try {
    const result = await MainService.getTriggerBot(orgId);

    const list = Object.values(result).map(flow => ({
      text: flow?.name?.replace(`${flow?.resourceId || ''}-`, '') || '',
      value: flow?.id || '',
    }));

    dispatch(setState({ botList: list || [] }));
  } catch (error) {
    dispatch(errorHandle(error));
  }
};

export default mainSlice.reducer;
